import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";

@Injectable()
export class EventService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public saveEvent(body: any): Observable<any> {
    return this.httpHelperService.post(`/sales/event`, body);
  }

  public getEventList(userId): Observable<any> {
    return this.httpHelperService.get(`/sales/event/admin?userId=${userId}`);
  }

  public setEventAlertArchived(body): Observable<any> {
    return this.httpHelperService.post(`/sales/event/archive/${body.id}`);
  }

  public getAllEventList(payload): Observable<any> {
    return this.httpHelperService.get(
      `/sales/event?time=${payload.time}&limit=${payload.limit}&userId=${payload.userId}`,
    );
  }
  public updateEvent(payload): Observable<any> {
    return this.httpHelperService.post(
      `/sales/event/${payload.eventId}`,
      payload,
    );
  }

  public getEventChannelList(): Observable<any> {
    return this.httpHelperService.get(`/sales/lov`);
  }
}
